import type { BadgeTone } from '@/shared/components/ui/Badge';
import type { MeetingStatus, MeetingPlatform } from './types';

/** Meeting-link providers offered in the scheduler. */
export const PLATFORM_OPTIONS: { value: MeetingPlatform; label: string; hint?: string; newUrl?: string }[] = [
  { value: 'google_meet', label: 'Google Meet', newUrl: 'https://meet.google.com/new' },
  { value: 'zoom', label: 'Zoom', newUrl: 'https://zoom.us/start/videomeeting' },
  { value: 'outlook', label: 'Outlook / Teams', newUrl: 'https://outlook.office.com/calendar/deeplink/compose' },
  { value: 'teams', label: 'Microsoft Teams', newUrl: 'https://teams.microsoft.com/l/meeting/new' },
  { value: 'in_person', label: 'In person', hint: 'No link needed' },
  { value: 'other', label: 'Other / custom link' },
];

export const PLATFORM_LABEL: Record<MeetingPlatform, string> = {
  google_meet: 'Google Meet',
  zoom: 'Zoom',
  outlook: 'Outlook',
  teams: 'Microsoft Teams',
  in_person: 'In person',
  other: 'Other',
};

export const DURATION_OPTIONS = [
  { value: '15', label: '15 min' },
  { value: '30', label: '30 min' },
  { value: '45', label: '45 min' },
  { value: '60', label: '1 hour' },
  { value: '90', label: '1.5 hours' },
  { value: '120', label: '2 hours' },
];

export const STATUS_OPTIONS = [
  { value: 'scheduled', label: 'Scheduled' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

export const STATUS_TONE: Record<MeetingStatus, BadgeTone> = {
  scheduled: 'info',
  completed: 'success',
  cancelled: 'danger',
};

export const STATUS_LABEL: Record<MeetingStatus, string> = {
  scheduled: 'Scheduled',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

/** Human-friendly date label (e.g. "5 Feb 2030"). */
export function formatDate(date?: string): string {
  if (!date) return '—';
  const d = new Date(`${date}T00:00:00`);
  if (Number.isNaN(d.getTime())) return date;
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

/** Combined date + time label for cards/drawer. */
export function formatWhen(date?: string, time?: string): string {
  const d = formatDate(date);
  return time ? `${d} · ${time}` : d;
}
